<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >

    <block-hero
      :target-info="targetInfo"
      :color-scheme="colorScheme"
    />

    <block-descriptions />

    <go-uranai-tv
      :upper-caption="'法演の占いが<br>月額528円（税込）で<br>55メニュー占い放題！'"
      :lower-caption="'他、TVや雑誌で活躍している占い師の鑑定を<br>2,000メニュー以上占えます。'"
      :ga-event-categ="`LP${lpId}-subsc-button`"
      :ga-event-label="'episode'"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
    />

    <block-about-mitsuri />

    <block-lead-free
      :color-scheme="colorScheme"
      :lp-id="lpId"
      @link="clickLink"
     />

    <!-- <block-about-fortune
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :lp-id="lpId"
      :banner-type="bannerType"
    /> -->

    <!-- <block-review
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :review-list="reviewListMod"
      :lp-id="lpId"
    /> -->

    <template v-if="!hideAddvertise">
      <!-- <block-menus
        v-if="menusList && menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :lp-id="lpId"
        :subscr-enable="+salesInvalid > 0"
      /> -->
      <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
      <!--
      <block-banner
        class="block-banner--middle"
        v-if="showBanner"
        banner-pos="middle"
        :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
        :lp-id="lpId"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="true"
      />
      -->
      <!-- <block-uranai-tv
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :is-individualed="true"
      /> -->
      <block-uranai-tv-desc-2
        :lp-id="lpId"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        @link="clickLink"
      />
    </template>

    <block-about-counselor
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :lp-id="lpId"
    />

    <!--
    <block-banner
      v-if="showBanner"
      banner-pos="bottom"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :lp-id="lpId"
      :campaign="bannerType"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
    />
    -->
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockReview from '@/utvStore/components/recommend/lp/blocks/BlockReview'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockUranaiTv from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTv'
import BlockHero from './blocks/BlockHero'
import BlockDescriptions from './blocks/BlockDescriptions'
import BlockAboutCounselor from './blocks/BlockAboutCounselor'
import BlockAboutFortune from './blocks/BlockAboutFortune'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import GoUranaiTv from '@/utvStore/components/recommend/lp/partials/GoUranaiTv'
import BlockAboutMitsuri from './blocks/BlockAboutMitsuri'
import BlockLeadFree from './blocks/BlockLeadFree'
import BlockUranaiTvDesc2 from '@/utvStore/components/recommend/lp/counselor/houen/blocks/BlockUranaiTvDesc2'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockDescriptions,
    BlockHero,
    BlockAboutCounselor,
    BlockAboutFortune,
    BlockReview,
    BlockMenus,
    BlockUranaiTv,
    BlockBanner,
    LineCampaignMessage,
    GoUranaiTv,
    BlockAboutMitsuri,
    BlockLeadFree,
    BlockUranaiTvDesc2,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default() {
        return []
      }
    },
    menusTabList: {
      type: Array,
      default() {
        return []
      }
    },
    targetInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    reviewList: {
      type: Array,
      default() {
        return []
      }
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    bannerType: {
      type: String,
      // default: 'LINE',
      default: null,
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
  },
  computed: {
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
  methods: {
    clickLink (payload) {
      // console.log('clickLink:', payload)
      window.gtag('event', 'click', payload.param)
      let href = payload.link
      if (href === 'subsc') { href = this.subscUrl }
      if (href) { location.href = this.$handoverParams(href) }
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.color-test {
  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #ddd;
    margin-right: 2px;

    &.key-color {
      background: $l_col_keycolor;
    }

    &.second {
      background: $l_col_second;
    }

    &.grad-start {
      background: $l_col_grad_start;
    }

    &.grad-end {
      background: $l_col_grad_end;
    }

    &.gradiation {
      width: 100px;
      background: linear-gradient(86.51deg, $l_col_grad_start 21.4%, $l_col_grad_end 76.64%);
    }
  }
}

.btn-base {
  width: 100%;
  padding: 20px;
}

.lp-child-base {
  color: #32373F;

  &--validCpno {
    .block-review-base {
      padding-bottom: 0;
    }
  }

  &--invalidCpno {
  }

  .block-about-fortune-base {
    background: #F9F5ED;
  }

  .block-menu-base {
    background: #F3FFEF;
    padding-bottom: 22px;
  }

  .block-uranaitv-base {
    background: #F5F5F5;
    padding-top: 36px;
  }

  .block-banner--middle {
    background: #F3FFEF;
    padding: 8px 20px 60px;
  }

  /deep/ {
    .block-about-fortune-base__you-comment {
      background: #EDED67;

      &::after {
        border-left-color: #EDED67;
      }
    }

    .block-about-fortune-base__method-advice {
      margin-right: -10px;
    }

    .block-about-fortune-base__free-curve {
      fill: #F9F5ED;
    }

    .block-uranaitv-base {
      &__menu {
        background: #fff;
      }
      &__point-btn,
      &__tokuten-btn {
        @include mq('w580'){
          max-width: 320px;
        }
      }
    }

    .go-uranaitv-base {
      background: white;
      padding-top: 60px;

      &__point-copy {
        @include mq('w580') {
          font-size: 30px;
          line-height: 38px;
          margin: 0 0 28px;
        }
      }

      &__lower-copy {
        @include mq('w580') {
          margin: 28px 0 0;
        }
      }
      .btn-wrap {
        @include mq('w580'){
          max-width: 320px;
        }
      }
    }

    .block-about-counselor-base {
      h2 {
        display: none;
      }
    }

    .block-about-fortune-base {
      &__box.first {
        margin-bottom: 44px;
      }

      .block-banner {
        display: none;
      }
    }
    .baseButton__button--fill {
      @include mq('w580'){
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/LpMain.vue